import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RiaFeeSetup from '.';
import ModifyFeeSetup from './ModifyFeeSetup';
import FeeSetupHistory from './FeeSetupHistory';
import { CommonLayout } from '../../commonComponents';

const routerList = [
    {
        name: 'Ria Fee Setup',
        path: "",
        component: RiaFeeSetup,
    },
    {
        name: "Modify Ria Fee Setup",
        path: ":familyId/modify",
        component: ModifyFeeSetup,
    },
    {
        name: 'History',
        path: 'history',
        component: FeeSetupHistory,
    }
]


function Routes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

export default function RiaFeeSetupRouter(): JSX.Element {

    return (
        <CommonLayout>
            <Routes />
        </CommonLayout>
    )
}
